import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'file-with-speaker';

const originalDimensions = {
    width: 24,
    height: 24,
};

// A custom icon created by layering stockholm-icon-set/Media/Mute.svg over the top of
// stockholm-icon-set/Files/File-minus.svg

export const IconFileWithSpeakerMute = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>File with Speaker Icon</title>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <g fill="none" fillRule="evenodd">
                    <path d="M24 0v24H0V0z" />
                    <path
                        d="M5.857 2h7.88a1.5 1.5 0 0 1 .968.355l4.764 4.029A1.5 1.5 0 0 1 20 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z"
                        fill={fill}
                        fillRule="nonzero"
                        opacity=".3"
                    />
                </g>
                <g fill="none" fillRule="evenodd">
                    <path d="M4.79 5.481h15.325v14.22H4.79z" />
                    <path
                        d="m16.02 12.59-.904-.837a.563.563 0 0 1 0-.838.674.674 0 0 1 .903 0l.903.838.903-.838a.674.674 0 0 1 .904 0c.249.231.249.607 0 .838l-.904.838.904.838c.249.231.249.606 0 .838a.674.674 0 0 1-.904 0l-.903-.838-.903.838a.674.674 0 0 1-.903 0 .563.563 0 0 1 0-.838z"
                        fill={fill}
                        opacity=".3"
                    />
                    <path
                        d="m9.26 14.96-2.167-.401c-.597-.111-1.026-.597-1.026-1.162v-1.612c0-.565.43-1.051 1.026-1.162l2.166-.402 2.103-1.951a.674.674 0 0 1 .903 0c.12.111.187.262.187.419v7.804c0 .327-.286.592-.638.592a.665.665 0 0 1-.452-.173z"
                        fill={fill}
                    />
                </g>
            </svg>
        </svg>
    );
};
